export default __webpack_public_path__ + "static/30-techwear-86063e133b4ac40346439f5ce0fbd442.png";